import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Pagination } from "react-bootstrap";
import moment from "moment";
import { API_END_POINT } from "../config";
import Cookie from "js-cookie";
const token = Cookie.get("waffle_world_access_token");

import HasRole from "../hoc/HasRole";

export default class Covervideo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      videos: [],
      activePage: 1,
      pages: 1,
      q: "",
      responseMessage: "Loading videos...",
    };
  }
  componentWillMount() {
    this.fetchvideos();
  }

  fetchvideos = () => {
    axios
      .get(`${API_END_POINT}/api/videos`, { headers: { "auth-token": token } })
      .then((response) => {
        this.setState({
          videos: response.data.objects,
          pages: Math.ceil(response.data.objects.length / 10),
          responseMessage: "No videos Found...",
        });
      });
  };

  // const requestParams = {
  //   "userId": userId,
  // }

  deletevideo(videoId, index) {
    const requestParams = {
      videoId: videoId,
    };
    if (confirm("Are you sure you want to delete this item?")) {
      axios
        .delete(`${API_END_POINT}/api/videos/delete`, {
          data: requestParams,
          headers: { "auth-token": token },
        })
        .then((response) => {
          const videos = this.state.videos.slice();
          videos.splice(index, 1);
          this.setState({ videos });
          window.alert(response.data.msg);
        });
    }
  }

  handleSelect(page) {
    axios.get(`/api/area?offset=${(page - 1) * 10}`).then((response) => {
      this.setState({
        areas: response.data.items,
        activePage: page,
      });
    });
  }

  handleSearch() {
    const { q } = this.state;
    if (q.length) {
      this.setState({
        loading: true,
        videos: [],
        responseMessage: "Loading videos...",
      });
      axios
        .get(`${API_END_POINT}/api/videos/search`, {
          params: { searchWord: this.state.q },
          headers: { "auth-token": token },
        })
        .then((response) => {
          this.setState({
            videos: response.data.searchedItems,
            loading: false,
            responseMessage: "No videos Found...",
          });
        })
        .catch(() => {
          this.setState({
            loading: false,
            responseMessage: "No videos Found...",
          });
        });
    }
  }

  render() {
    return (
      <div className="row animated fadeIn">
        <div className="col-12">
          <div className="row space-1">
            <div className="col-sm-4">
              <h3>Liste der Videos</h3>
            </div>
            <div className="col-sm-4">
              <div className="input-group">
                <input
                  className="form-control"
                  type="text"
                  name="search"
                  placeholder="Enter keyword"
                  value={this.state.q}
                  // onChange={(event) => this.setState({q: event.target.value})}
                  onChange={(event) =>
                    this.setState({ q: event.target.value }, () => {
                      if (this.state.q === "") {
                        this.fetchvideos();
                      }
                    })
                  }
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      this.handleSearch();
                    }
                  }}
                />
                <span className="input-group-btn">
                  <button
                    type="button"
                    onClick={() => this.handleSearch()}
                    className="btn btn-info search-btn"
                  >
                    Suchen
                  </button>
                </span>
              </div>
            </div>

            <div className="col-sm-4 pull-right mobile-space">
              <Link to="/videos/video_form">
                <button type="button" className="btn btn-success">
                  Neues Video hinzufügen
                </button>
              </Link>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Sr. #</th>
                  {/* <th>Id</th> */}
                  <th>Name</th>
                  <th>Video URL</th>
                  <th>Beschreibung</th>
                </tr>
              </thead>
              <tbody>
                {this.state.videos && this.state.videos.length >= 1 ? (
                  this.state.videos.map((video, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      {/* <td>{video._id}</td> */}
                      <td>{video.name}</td>
                      <td>{video.videoUrl}</td>
                      <td>{video.description}</td>
                      <td>
                        <Link to={`/videos/edit_video/${video._id}`}>
                          <span
                            className="fa fa-edit"
                            aria-hidden="true"
                          ></span>
                        </Link>
                      </td>
                      <td>
                        <span
                          className="fa fa-trash"
                          aria-hidden="true"
                          style={{ cursor: "pointer" }}
                          onClick={() => this.deletevideo(video._id, index)}
                        ></span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="15" className="text-center">
                      {this.state.responseMessage}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {/* <div className="text-center">
            <Pagination prev next items={this.state.pages} activePage={this.state.activePage} onSelect={this.handleSelect.bind(this)}> </Pagination>
          </div> */}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Videos.jsx